import { Loader2 } from 'lucide-react'

import i18n from '@/i18n'

interface FullscreenLoaderProps {
  text?: string
}

/** 全屏加载：与新设计语言一致，使用 mint 环状 spinner，并让底层氛围光透出 */
export function FullscreenLoader({ text }: FullscreenLoaderProps) {
  const label = text ?? i18n.t('common.loading')

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="relative mb-5 flex h-20 w-20 items-center justify-center">
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-full border border-white/[0.06] bg-white/[0.03] shadow-[inset_0_1px_0_rgba(255,255,255,0.05)] backdrop-blur-xl"
        />
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-full bg-[#5eead4]/12 blur-2xl"
        />
        <Loader2 className="relative h-8 w-8 animate-spin text-[#5eead4]" />
      </div>
      <p className="animate-pulse text-xs font-medium tracking-wide text-gray-400">{label}</p>
    </div>
  )
}
